import notify from 'components/atoms/Notify'
import isEmpty from 'lodash/isEmpty'
import { parseCookies } from 'nookies'
import refreshToken from './refreshToken'

const baseUrl = process.env.REACT_APP_BASE_URL

const apiDelete = async (query, retryCount = 0) => {
  const { accessToken, workspaceID } = parseCookies()

  const config = {
    method: 'DELETE',
  }

  if (!isEmpty(accessToken)) {
    config.headers = {
      Authorization: accessToken,
      workspaceID,
      ...config.headers,
    }
  }

  const response = await fetch(`${baseUrl}/admin/${query}`, config)
  const responseData = await response.json()

  if (response.status === 403 && retryCount === 0) {
    const refreshed = await refreshToken()
    if (refreshed) {
      return apiDelete(query, retryCount + 1)
    } else {
      notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
      return responseData
    }
  }

  if (!responseData.success) {
    notify.error(responseData.message, null, responseData.err)
  }
  return responseData
}

export default apiDelete

export const crmApiDeleteLead = leadId => apiDelete(`crm/leads/${leadId}`)
